/*     标准代码提供者
 归属：企通前端平台-ECP V5.1
 版权：2014-2020 企通软件技术有限公司
 --------------------------------------------------------------------------------
 作者：纪青君                         创建日期：2014/03/13
 修改：                               修改日期：
 修改内容
 --------------------------------------------------------------------------------
 这里向使用者提供根据代码ID，获得代码的方法getSC(scID)
 scID 符合XXXX,xx`xx`xx...的定义规则
 输入参数scID包含的项不同，你得到的结果也不同，例如：
 getSC（XXXX），你可能得到的是一个代码数组或代码树。
 getSC(XXXX,xx)，你可能得到的是一个具体的代码值，也可能你得到的还是一个代码
 数组或代码树，这样依据你的代码结构而定。
 
 !!!! 目前采用程序直接量的方式定义各种代码，最终将改为从参数中读取，但对外接口将保持不变
 --------------------------------------------------------------------------------
 修改： liux                              修改日期：2014/04/30
 修改内容
 getSC方法修改为使用参数工厂从参数库中读取一个代码。
 指定的scID可以使一个代码参数的GUID，也可以是某个代码参数中的任意子节点的sGUID。
 但是该方法返回的是参数的json形式对象或json对象的数组,而不是一个model对象。
 --------------------------------------------------------------------------------
 //0XXX：控件公共信息
 //1XXX：容器控件
 //2XXX：基本控件
 //3XXX：自定义控件
 //4XXX：布局属性
 //5XXX: 图形控件
 //6XXX—8XXX:保留
 //9XXX:公共
 
 *******************************************************************************/
import { PrmFactory } from './PrmFactory';
var SCMap;
var MediaResourceCode = {

	getPrmUrl: function (scID) {
		if (!scID) {
			return null;
		}
		if (typeof (scID) != "string") {
			return null;
		}
		var fileUrl;
		var ms = scID.split("`");
		var mguid = ms[0];
		if (!SCMap) {
			var prm = this.prmInit(mguid, ms);
			if (prm) {
				fileUrl = prm.c;
			}
		} else {

		}

		return fileUrl;
	},
	prmInit: function (mguid, ms) {
		SCMap = {};
		var json = PrmFactory.getPrm(mguid);
		var length = ms.length;
		for (var i = 1; i < length; i++) {
			json = PrmFactory.findMenber(json, ms[i]);
		}
		SCMap[mguid] = json;
		return json;
	},


}
export { MediaResourceCode };
export default MediaResourceCode;



// WEBPACK FOOTER //
// ./~/rt-sd-common/sgiFactory/MediaResourceCode.js